import { resolveComponent as n, createElementBlock as t, openBlock as r, createVNode as c, createTextVNode as p, toDisplayString as s } from "vue";
import { _ as a } from "../plugin-vue.CHgC5LLL.js";
const i = {
  props: {
    verb: {
      type: String,
      default: "Loading"
    }
  }
};
function _(m, f, e, l, d, u) {
  const o = n("font-awesome-icon");
  return r(), t("p", null, [
    c(o, {
      icon: "spinner",
      spin: ""
    }),
    p(" " + s(e.verb) + ", please wait...", 1)
  ]);
}
const v = /* @__PURE__ */ a(i, [["render", _]]);
export {
  v as L
};
